// extracted by mini-css-extract-plugin
export default {"formContainer":"InputCheckbox_formContainer__-HSZu","error":"InputCheckbox_error__grE-X","invalidInput":"InputCheckbox_invalidInput__dXaTp"};